<div class="sidebar">
  <div class="logo_content">
    <div class="logo">
      <img class="img-fluid h-100" [src]="logo" alt="">
      <!-- <div class="logo_name">Inventar</div> -->
    </div>
    <i id="btn" class="bx bx-menu"></i>
  </div>
  <ul class="nav">
    <!-- <li *ngIf="user.role.name === 'root'">
      <a>
        <i class='bx orange bx-grid-alt'></i>
        <span class="links_name">Dashboard</span>
      </a>
      <span class="tooltip">Dashboard</span>
    </li> -->
    <li *ngIf="user.role.name === 'root'">
      <a href="" routerLink="/root/companies" routerLinkActive="active_item">
        <i class='bx orange bx-buildings'></i>
        <span class="links_name" translate>navigation.companies</span>
      </a>
      <span class="tooltip" translate>navigation.companies</span>
    </li>
    <li *ngIf="user.role.name === 'root'">
      <a href="" routerLink="/root/images" routerLinkActive="active_item">
        <i class='bx bx-images orange'></i>
        <span class="links_name" translate>navigation.images</span>
      </a>
      <span class="tooltip" translate>navigation.images</span>
    </li>

    <li *ngIf="user.role.name === 'root'">
      <a href="" routerLink="/root/filials" routerLinkActive="active_item">
        <i class='bx bx-buildings orange'></i>
        <span class="links_name" translate>navigation.filials</span>
      </a>
      <span class="tooltip" translate>navigation.filials</span>
    </li>

    <li *ngIf="user.role.name === 'root'">
      <a href="" routerLink="/root/inventars" routerLinkActive="active_item">
        <i class='bx bx-buildings orange'></i>
        <span class="links_name" translate>navigation.inventars</span>
      </a>
      <span class="tooltip" translate>navigation.inventars</span>
    </li>
    <li *ngIf="user.role.name === 'root'">
      <a href="" routerLink="/root/products" routerLinkActive="active_item">
        <i class='bx bx-buildings orange'></i>
        <span class="links_name" translate>navigation.products</span>
      </a>
      <span class="tooltip" translate>navigation.products</span>
    </li>
    <!-- <li *ngIf="user.role.name === 'root'">
      <a>
        <i class='bx orange bx-history'></i>
        <span class="links_name">History</span>
      </a>
      <span class="tooltip">History</span>
    </li> -->
    <!-- user -->
    <li *ngIf="user.role.name === 'user'">
      <a href="" routerLink="/filials" routerLinkActive="active_item">
        <i class='bx orange bx-buildings'></i>
        <span class="links_name" translate>navigation.filials</span>
      </a>
      <span class="tooltip" translate>navigation.filials</span>
    </li>
    <li *ngIf="user.role.name === 'user'">
      <a href="" routerLink="/filials-admins" routerLinkActive="active_item">
        <i class='bx orange bx-group'></i>
        <span class="links_name" translate>navigation.filialsAdmins</span>
      </a>
      <span class="tooltip" translate>navigation.filialsAdmins</span>
    </li>
    <li *ngIf="user.role.name === 'user'">
      <a href="" routerLink="/workers" routerLinkActive="active_item">
        <i class='bx orange bx-group'></i>
        <span class="links_name" translate>navigation.workers</span>
      </a>
      <span class="tooltip" translate>navigation.workers</span>
    </li>
    <!-- webhooks -->
    <li *ngIf="user.role.name === 'user'">
      <a href="" routerLink="/webhooks" routerLinkActive="active_item">
        <i class='bx orange bx-history'></i>
        <span class="links_name" translate>navigation.webhooks</span>
      </a>
      <span class="tooltip" translate>navigation.webhooks</span>
    </li>

    <li *ngIf="user.role.name === 'user'">
      <a href="" routerLink="/thirdPartyAPIs" routerLinkActive="active_item">
        <i class='bx orange bx-history'></i>
        <span class="links_name" translate>navigation.thirdPartyAPIs</span>
      </a>
      <span class="tooltip" translate>navigation.thirdPartyAPIs</span>
    </li>

    <li *ngIf="user.role.name === 'filialAdmin'">
      <a href="" routerLink="/admin/filials" routerLinkActive="active_item">
        <i class='bx orange bx-buildings'></i>
        <span class="links_name" translate>navigation.filials</span>
      </a>
      <span class="tooltip" translate>navigation.filials</span>
    </li>
    <li *ngIf="user.role.name === 'filialAdmin'">
      <a href="" routerLink="/admin/workers" routerLinkActive="active_item">
        <i class='bx orange bx-group'></i>
        <span class="links_name" translate>navigation.workers</span>
      </a>
      <span class="tooltip" translate>navigation.workers</span>
    </li>
     <li *ngIf="user.role.name === 'worker'">
      <a href="" routerLink="/worker/inventars" routerLinkActive="active_item">
        <i class='bx orange bx-buildings'></i>
        <span class="links_name" translate>navigation.inventars</span>
      </a>
      <span class="tooltip" translate>navigation.inventars</span>
    </li>
  </ul>
  <hr>
  <div>
    <div class="lang" style="cursor: pointer; display: flex;" (click)="openDropdown()">
      <p class="me-1">{{language | uppercase}}</p>
      <i class="fa fa-sort-down"></i>
    </div>
    <div *ngIf="showLanguages" class="languages">
      <div class="d-flex pt-2 lang-container" (click)="useLanguage('en')">
        <img class="small-img" src="../../../assets/img/usa.png" alt="">
        <p class="m-0">EN</p>
      </div>
      <div class="d-flex pt-2 lang-container" (click)="useLanguage('de')">
        <img class="small-img" src="../../../assets/img/germany.webp" alt="">
        <p class="m-0">DE</p>
      </div>
      <div class="d-flex pt-2 lang-container" (click)="useLanguage('fr')">
        <img class="small-img" src="../../../assets/img/fr.png" alt="">
        <p class="m-0">FR</p>
      </div>
    </div>
  </div>
  <div class="profile_content">
    <div class="profile">
      <div class="profile_details">
        <div *ngIf = "user.role.name !== 'root'">
        <ng-template [ngIf]="user.profileImage !== null" [ngIfElse]="uploadImage">
          <img  src="{{user.profileImage}}" (click)="openUploadImageModal()" alt="">
        </ng-template>
        <ng-template #uploadImage>
          <i class='bx orange bx-upload' (click)="openUploadImageModal()" ngbTooltip="Upload Profile Image" placement="top-left" ></i>
        </ng-template>
      </div>
        <div class="name_job">
          <div class="name">{{user?.name}}</div>
          <div class="job">{{user?.role.name | titlecase}}</div>
        </div>
      </div>
      <i class='bx orange bx-log-out' (click)="logout()" id="log_out"></i>
    </div>
  </div>
</div>
<div class="home_content">
  <span class="p-3 burger" (click)="openSidebar()">
    <i id="btn" class="bx bx-menu"></i>
  </span>
  <router-outlet></router-outlet>
</div>

<app-modal (close)="toggleUploadImage = !toggleUploadImage" *ngIf="toggleUploadImage">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;">Upload profile image</h4>
    </div>
    <div class="modal-body text-center">
      <img class="my-3" [src]="url" height="200"> <br/>
      <input type='file' (change)="onSelectFile($event)">
    </div>
  </div>
  <div class="modal-footer justify-content-start">
    <app-button [text]="'global.save'" (click)="uploadFile()"></app-button>
  </div>
</app-modal>